const initState = {
  loading: false,
  success: false,
  error: null,
  lastGrantData: null,
};

const capabilityGrant = (state = initState, action) => {
  switch (action.type) {
    case 'GRANT_CAPABILITY_LOADING':
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case 'GRANT_CAPABILITY_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        lastGrantData: action.data,
      };
    case 'GRANT_CAPABILITY_ERROR':
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };
    case 'RESET_CAPABILITY_GRANT':
      return initState;
    default:
      return state;
  }
};

export default capabilityGrant;
